import { useSelector } from "@tanstack/react-form";
import { TextAreaInput, type TextAreaProps } from "../../form-fields/components/text-area";
import { Stack } from "../../stack";
import { useFieldContext } from "../form/form-context";
import { FieldInfo } from "./fieldinfo";

type TextAreaFieldProps = {
	helperText?: string;
} & TextAreaProps;

export const TextAreaField = ({
	label,
	type = "text",
	helperText,
	...rest
}: TextAreaFieldProps) => {
	const field = useFieldContext<string>();
	const meta = useSelector(field.store, (state) => state.meta);

	return (
		<Stack gap={2}>
			<TextAreaInput
				type={type}
				label={label}
				autoComplete="off"
				id={field.name}
				name={field.name}
				value={field.state.value}
				onBlur={field.handleBlur}
				onChange={(e) => field.handleChange(e.target.value)}
				error={meta.errors.length > 0}
				{...rest}
			/>
			<FieldInfo field={field} helperText={helperText} />
		</Stack>
	);
};
